import type { UserSearchHit } from '@citibox-panel/api-client';
import { firstActiveRecipient } from '../../../lib/firstActiveRecipient';

// The stored address of THIS «Entrega»'s titular, among the accounts its phone resolves to. A phone
// can resolve to more than one, and the detail names the titular's id, so matching on it is strictly
// better than the generic tie-break — which stays as the fallback when the delivery carries no id.
//
// The id crosses a type boundary: a hit carries it as a string, the detail as a number (the same
// crossing recipientEligibility documents). An empty address — an anonymized account keeps its hit
// but not its address — answers null, so there is nothing to compare.
export function titularAddress(hits: UserSearchHit[], recipientId: number | null): string | null {
  const titular =
    recipientId === null
      ? firstActiveRecipient(hits)
      : hits.find((hit) => Number(hit.id) === recipientId);
  const address = titular?.address ?? '';
  return address === '' ? null : address;
}
